import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/company/types'
import CompanyEntity, { ICompanyProps } from '@/entities/Company'
import { IResponseProps } from '@/entities/Response'

export default class CompanyRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<ICompanyProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<ICompanyProps> {
    return this.store.state.company.response
  }

  set current(value: ICompanyProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): ICompanyProps | null {
    return this.store.state.company.current
  }

  get entity(): CompanyEntity {
    return new CompanyEntity(this.store.state.company.current)
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.company.filter
  }
}
